import { useTranslation } from "react-i18next";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";

const Footer = ({ project, logo, company, address, phone, instagram, facebook, tiktok = "https://tiktok.com/@paksongmedan" }) => {
        const { t, i18n } = useTranslation();
    
    return (
        <footer
            id="kontak"
            className=" text-white overflow-hidden bg-gradient-to-r from-green-600 to-green-800 "
            style={{
                padding: "40px 20px",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    maxWidth: "1200px",
                    margin: "0 auto",
                }}
            >
                {/* Alamat & Sosial Media */}
                <div style={{ flex: "1 1 300px", marginBottom: "20px" }}>
                    {logo ? (
                        <img
                            src={logo}
                            alt="Logo"
                            className="w-20 h-10 mr-3 object-cover"
                        />
                    ) : (
                        <h1
                            className="text-xl font-bold cursor-pointer">
                            {project ?? "Project"}
                        </h1>
                    )}
                    <h3>{t('label_address')} </h3>
                    <p>
                        {address} <br />
                        {t('label_telp')} : {phone}
                    </p>
                    <div style={{ display: "flex", marginTop: "10px" }}>
                        <a
                            href={facebook}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: "white",
                                marginRight: "10px",
                                fontSize: "20px",
                            }}
                        >
                            <FaFacebookF />
                        </a>
                        <a
                            href={instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: "white",
                                marginRight: "10px",
                                fontSize: "20px",
                            }}
                        >
                            <FaInstagram />
                        </a>
                        <a
                            href={tiktok}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: "white",
                                fontSize: "20px",
                            }}
                        >
                            <FaTiktok />
                        </a>
                    </div>
                </div>

                {/* Tengah - Fitur Populer */}
                <div style={{ flex: "1 1 300px", marginBottom: "20px" }}>
                    <h3>{t('info_service')}</h3>
                    <ul style={{ listStyle: "none", padding: 0 }}>
                        <li>{t('rent_daily_weekley')} </li>
                        <li>{t('driver_pro')}</li>
                        <li>{t('units')}</li>
                        <li>{t('ready_to_airport')}</li>
                    </ul>
                </div>

                {/* Kanan - Jadwal & Jam Operasional */}
                <div style={{ flex: "1 1 300px", marginBottom: "20px" }}>
                    <h3>{t('operating_hours')}</h3>
                    <ul style={{ listStyle: "none", padding: 0 }}>
                        <li>{t('operating_hours_weekdaty')}</li>
                        <li>{t('operating_hours_saturday')}</li>
                        <li>{t('operating_hours_sunday')}</li>
                    </ul>
                </div>
            </div>

            {/* Bottom Copyright */}
            <div
                style={{
                    textAlign: "center",
                    marginTop: "20px",
                    fontSize: "14px",
                    borderTop: "1px solid rgba(255,255,255,0.2)",
                    paddingTop: "10px",
                }}
            >
                © {new Date().getFullYear()} {company}. All rights reserved.
            </div>
            <p className="text-sm text-center">
                Made with <span className="text-red-500">❤️</span> by{" "}
                <a
                    href="https://softwaremedan.com"
                    className="text-green-400 hover:underline"
                >
                    softwaremedan.com
                </a>
            </p>
        </footer>
    );
};

export default Footer;
